var _path, _line, _line2, _line3, _line4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBwIcon = function SvgBwIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    width: 24,
    stroke: "currentColor",
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1414_11787",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 11,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.375L16.125 7.5L7.875 16.5L7.5 16.125L6 14.25V10.5L8.25 7.5L10.125 6L13.5 6.375Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.110239, 0, 0, 1.101418, -7.565907, -6.92285)",
    style: {}
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {},
    transform: "matrix(1.462065, 0, 0, 1.407015, 0.000307, 0.178816)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.028,
    y1: 12.224,
    x2: 12.517,
    y2: 22.339,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1414_11787)",
    style: {},
    transform: "matrix(1.462065, 0, 0, 1.407015, 0.000307, 0.178816)"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.8612,
    y1: 13.8796,
    x2: 5.5423,
    y2: -0.439336,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18.4159,
    y1: 16.5312,
    x2: 4.09699,
    y2: 2.21234,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5682,
    y1: 18.4329,
    x2: 2.24934,
    y2: 4.11395,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14.3182,
    y1: 20.3344,
    x2: -0.000664771,
    y2: 6.0155,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBwIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "c9c6242c0d25bbff350b58a7be727813.svg";